import Control from '../Control';
import classnames from 'classnames';

import Fragment from '../inspector/Fragment';
import Inspector from '../inspector/Inspector';

const SelectControl = wp.components.SelectControl;

export default class Layouts extends Control {
    /**
     * Add custom attribute for mobile visibility
     *
     * @param {Object} settings Settings for the block
     *
     * @return {Object} Modified settings
     */
    registerBlockType(settings) {
      //check if object exists for old Gutenberg version compatibility
      if (typeof settings.attributes !== 'undefined') {
        settings.attributes = Object.assign(settings.attributes, {
            LayoutsControl: {
            type: 'string',
            default: '',
          }
        });
      }
  
      return settings;
    }

  /**
   * Add mobile visibility controls as Block Panel
   *
   * @param {function} Block Block edit component
   *
   * @return {function} Modified block edit component
   */
  BlockEdit(Block, props) {
    const {
			attributes,
			setAttributes,
    } = props;

    const { LayoutsControl } = attributes;

    const options = this.options.options || [
      {
        label: 'Default',
        value: '',
      },
      {
        label: 'Container',
        value: 'container',
      },
      {
        label: 'Full Width',
        value: 'container--full',
      },
    ];

    return (
      <Fragment>
        <Block {...props} />
        <Inspector>
          <Inspector.Body
            title={this.options.label || 'Layouts'}
            initialOpen={false}
          >
            <Inspector.Row>
              <SelectControl
                label={'Layout'}
                value={LayoutsControl}
                onChange={ (val) => setAttributes( { LayoutsControl: val } ) }
                options={options}
              />
            </Inspector.Row>
          </Inspector.Body>
        </Inspector>
      </Fragment>
    );
  }

  /**
   * Add custom element class on save element
   *
   * @param {Object} props Block element
   * @param {Object} blockType Blocks object
   * @param {Object} attributes Blocks attributes
   *
   * @return {Object} Modified block element.
   */
  extraProps(props, blockType, attributes) {
    const { LayoutsControl } = attributes;

    //check if attribute exists for old Gutenberg version compatibility
    if (typeof LayoutsControl !== 'undefined') {
      props.className = classnames(props.className, LayoutsControl);
    }

    return props;
  }
}